import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'
import { ChevronDownIcon } from '@repo/ui/icons'

type ChevronDownProps = {
  color: TailwindColor
  className?: string
  open?: boolean
  onClick?: () => void
}
export const ChevronDownContainer = ({ color, className, open, onClick }: ChevronDownProps) => {
  return (
    <div
      className={cn(
        'rounded-sm p-0.5 cursor-pointer transition-transform duration-200',
        {
          'transform rotate-180': open
        },
        className
      )}
      onClick={onClick}
    >
      <ChevronDownIcon color={color} width="22px" height="22px" />
    </div>
  )
}
